import React, { useState, useRef } from 'react'
import { PrismicRichText } from '@prismicio/react'
import { object } from 'prop-types'
import { v4 as uuidv4 } from 'uuid'
import * as Styled from './styles/Accordion.styles'

export const AccordionArrow = ({ toggle, isOpen }) => (
  <Styled.AccordionArrow
    onClick={() => toggle()}
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {!isOpen ? (
      <path
        d="M22.5 43C11.2 43 2 33.8 2 22.5S11.2 2 22.5 2 43 11.2 43 22.5 33.8 43 22.5 43zm0 2C10.1 45 0 34.9 0 22.5S10.1 0 22.5 0 45 10.1 45 22.5 34.9 45 22.5 45zm6.9-23.9c.4.4.4 1 0 1.4l-6.6 7.3c-.4.4-1.1.4-1.5 0l-6.6-7.3c-.4-.4-.4-1 0-1.4.4-.5 1.1-.5 1.5 0l4.8 5.3V14c0-.6.4-1 1-1s1 .4 1 1v12.4l4.8-5.3c.4-.4 1.1-.4 1.6 0z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1a5dc8"
      />
    ) : (
      <path
        d="M45 22.5C45 10.1 34.9 0 22.5 0S0 10.1 0 22.5 10.1 45 22.5 45 45 34.9 45 22.5zm-29.4 1.4c-.4-.4-.4-1 0-1.4l6.6-7.3c.4-.4 1.1-.4 1.5 0l6.6 7.3c.4.4.4 1 0 1.4-.4.5-1.1.5-1.5 0L24 18.6V31c0 .6-.4 1-1 1s-1-.4-1-1V18.6l-4.8 5.3c-.4.4-1.1.4-1.6 0z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1a5dc8"
      />
    )}
  </Styled.AccordionArrow>
)

const AccordionRow = ({ header, body }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [contentHeight, setContentHeight] = useState(0)
  const bodyContent = useRef(null)

  const toggle = () => {
    setContentHeight(isOpen === true ? 0 : bodyContent.current.scrollHeight)
    setIsOpen(!isOpen)
  }

  return (
    <Styled.AccordionRow>
      <AccordionArrow toggle={toggle} isOpen={isOpen} />
      <Styled.ExpandableContentBlock>
        <Styled.BlockHeader isOpen={isOpen} onClick={() => toggle()}>
          {header}
        </Styled.BlockHeader>
        <Styled.BlockCopy
          ref={bodyContent}
          isOpen={isOpen}
          contentHeight={contentHeight}
        >
          <PrismicRichText field={body.richText} />
        </Styled.BlockCopy>
      </Styled.ExpandableContentBlock>
    </Styled.AccordionRow>
  )
}

const Accordion = ({ data, bottomPaddingAdjustment }) => (
  <Styled.AccordionBlock bottomPaddingAdjustment={bottomPaddingAdjustment}>
    <Styled.SectionHeader>
      {data.primary.section_header?.text ?? ''}
    </Styled.SectionHeader>
    {data.items.map(item => (
      <AccordionRow
        key={uuidv4()}
        header={item.block_header?.text ?? ''}
        body={item.content}
      />
    ))}
  </Styled.AccordionBlock>
)

Accordion.propTypes = {
  data: object,
}

export default Accordion
